<template>
  <div class="service acea-row row-middle row-center">
    <img :src="imgUrl" class="img" alt="" />
  </div>
</template>

<script>
import { serverimg } from "@api/user";
export default {
  data() {
    return {
      imgUrl: ""
    };
  },
  mounted() {
    this.onServer();
  },
  methods: {
    onServer() {
      serverimg().then(res => {
        this.imgUrl = res.msg;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.service {
  width: 100%;
  height: 100vh;
}
.img {
  width: 300px;
  height: 300px;
}
</style>
